const SAVE = 'SAVE_ORDER';

export function orderReducer (state = [], action) {
    switch (action.type) {
        case SAVE:
            return action.payload;
        default:
            return state;
    }
}